import React, { FC } from "react";
import { Modal, notification } from "antd";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useCreateBatchMutation } from "shared/api";
import { handleRequestError } from "shared/helpers";
import { Colors } from "shared/themes";
import { BatchFormValues } from "../types";
import { BatchForm } from "./BatchForm";

interface AddBatchModalProps {
  isOpenModal: boolean;
  hideModal: () => void;
}

const AddBatchModal: FC<AddBatchModalProps> = ({ isOpenModal, hideModal }) => {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();
  const [createBatch, { isLoading }] = useCreateBatchMutation();

  const { values, resetForm, isValid } = useFormikContext<BatchFormValues>();

  const handleSubmit = async () => {
    if (!isValid) return;

    try {
      await createBatch(values).unwrap();

      api.success({
        message: t("success"),
        description: "Batch successfully created",
      });

      resetForm();
      hideModal();
    } catch (error) {
      api.error({
        message: t("error"),
        description: handleRequestError(error, "Failed to create batch"),
      });
    }
  };

  const handleCancel = () => {
    resetForm();
    hideModal();
  };

  return (
    <>
      {contextHolder}
      <Modal
        title="Add Batch"
        open={isOpenModal}
        onOk={handleSubmit}
        onCancel={handleCancel}
        confirmLoading={isLoading}
        width={600}
        bodyStyle={{ padding: "20px 24px" }}
        okButtonProps={{
          disabled: !isValid,
          style: {
            backgroundColor: Colors.blue.primary,
            color: "#fff",
            borderColor: Colors.blue.primary,
          },
        }}
      >
        <BatchForm />
      </Modal>
    </>
  );
};

export { AddBatchModal };
